export default __webpack_public_path__ + "static/media/ios-icon.68f731fb.svg";